import React, { Fragment, useContext, useEffect, useState } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { RequestNewInvitationStepValues } from "../../_interfaces/IAdminInvitationStepTypeValues";
import { IAdminInvitationFlowValues } from "../../_interfaces/IAdminInvitationFlowValues";
import LoadingIndicator from "../../../../../components/Shared/LoadingIndicator";
import { Container, createStyles, makeStyles, Paper, Theme } from "@material-ui/core";
import ErrorMessage from "../../../../../components/Shared/ErrorMessage";
import { RootContext } from "../../../../../stores";
import { useParams } from "react-router-dom";
import { AppError } from "../../../../../stores/models/errors/AppError";
import NewLinkRequested from "../../../../../components/Authentication/LinkVolunteerToOrganizationSteps/NewLinkRequested";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(4),
            display: 'inline-block',
            position: 'relative' // the loading spinner refers to this element
        },
    })
);

export const RequestNewInvitationStep: React.FC<StepRenderProps<
    RequestNewInvitationStepValues,
    IAdminInvitationFlowValues
>> = ({
    update,
    submit,
    canSubmit,
    validation,
}) => {

        /********* React hooks *********/

        const classes = useStyles();
        const rootStore = useContext(RootContext);
        const invitationStore = rootStore.invitationStore;
        const { token } = useParams() as { token: string };

        /********* State *********/

        const [apiResponse, setAPIResponse] = useState<{ success: boolean }>();
        const [error, setError] = useState<AppError>();
        const [isLoading, setIsLoading] = useState(false);

        /********* Effects *********/

        useEffect(() => {
            requestNewInvitation();
        }, [token])

        /********* API Requests *********/

        const requestNewInvitation = async () => {
            try {
                if (token) {
                    setIsLoading(true);
                    const response = await invitationStore.refreshAdminInvite(token);
                    if (response instanceof AppError) {
                        setError(response);
                    } else {
                        setAPIResponse(response);
                    }
                    setIsLoading(false);
                }
            } catch (err) {
                throw err;
            } finally {
                setIsLoading(false);
            }
        }

        /********* Event handlers *********/

        const onErrorActionButtonClicked = async () => {
            rootStore.navigationStore.appwideDialogStates.contactUsDialog.setOpen(true);
            rootStore.helpStore.setHelpMessageOverrides({
                subject: 'Error Refreshing Expired Invitation Link',
                message: ""
            });
            // switch (error?.code) {
            //     // case AppErrors.TOKEN_EXPIRED.code:
            //     //     return onRequestNewInvitationClicked();
            //     // case AppErrors.TOKEN_USED.code:
            //     // case AppErrors.NOT_FOUND.code:
            //     //     return onRequestNewInvitationClicked();
            //     default:
            //         break;
            // }
        }

        /********* Helper Methods *********/

        const getErrorTitleText = () => {
            return "Error requesting new link"
            // switch (error?.code) {
            //     // case AppErrors.NOT_FOUND.code:
            //     //     return 'Oops! This link is invalid.';
            //     // case AppErrors.TOKEN_USED.code:
            //     // case AppErrors.TOKEN_EXPIRED.code:
            //     //     return 'Oops! This link is no longer valid.';
            //     default:
            //         return "";
            // }
        }

        const getErrorDetailsText = () => {
            return "Please refresh and try again, or contact us if the problem persists."
            // switch (error?.code) {
            //     // case AppErrors.NOT_FOUND.code:
            //     //     return "Please double check that you've entered the link exactly as it appears in your email.";
            //     // case AppErrors.TOKEN_USED.code:
            //     //     return "The invitation has already been accepted.";
            //     // case AppErrors.TOKEN_EXPIRED.code:
            //     //     return `For security purposes, links expire after ${LINK_EXPIRATION_PERIOD}. Please request a new link to continue.`;
            //     default:
            //         return "";
            // }
        }

        const getErrorActionButtonText = () => {
            return "Contact Us"
            // switch (error?.code) {
            //     // case AppErrors.TOKEN_EXPIRED.code:
            //     //     return "Request New Link";
            //     // case AppErrors.TOKEN_USED.code:
            //     // // return 'Navigate to Profile';
            //     // case AppErrors.NOT_FOUND.code:
            //     //     return "Request New Link";
            //     default:
            //         return undefined;
            // }
        }

        const errorActionButtonText = getErrorActionButtonText();

        /********* Render *********/

        return (
            <Fragment>
                {isLoading
                    ? <LoadingIndicator />
                    : <Container>
                        <Paper className={classes.content}>
                            {apiResponse?.success
                                ? <NewLinkRequested />
                                : <ErrorMessage
                                    title={getErrorTitleText()}
                                    details={getErrorDetailsText()}
                                    ButtonProps={
                                        errorActionButtonText
                                            ? {
                                                children: errorActionButtonText,
                                                onClick: onErrorActionButtonClicked,
                                                disabled: !canSubmit
                                            }
                                            : undefined
                                    }
                                />
                            }
                        </Paper>
                    </Container>
                }
            </Fragment>
        );
    };
